import { Grid } from '@mui/material';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';

import { ServiceContract } from '@work4all/models/lib/Classes/ServiceContract.entity';

import { BaseDataLanguagePickerField } from '../../../../../../../../../../components/entity-picker/BaseDataLanguagePickerField';
import { ControllerPlus } from '../../../../../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../../../../../form-plus/use-form-context-plus';
import {
  CheckboxRadioItem,
  LabeledInput,
} from '../../../../../../../../locked-inputs';
import { TabPanelSectionProps } from '../../../../../../..';
import { useMaskContext } from '../../../../../../../hooks/mask-context';
import { ServiceContractsFormValue } from '../../../../../types';

export const Description: React.FC<TabPanelSectionProps> = () => {
  const { t } = useTranslation();

  const { control, register } = useFormContextPlus<ServiceContractsFormValue>();
  const isPermanentInvoice = useWatch({ control, name: 'permanentInvoice' });

  const mask = useMaskContext<ServiceContract>();

  return (
    <Collapse title={t('MASK.DESCRIPTION')} defaultOpen={true}>
      <Grid container spacing="1rem">
        <Grid item xs={12} md={12} lg={8}>
          <LabeledInput
            {...register('name')}
            required
            label={t('INPUTS.DESCRIPTION')}
          />
        </Grid>
        <Grid item xs={12} md={12} lg={4}>
          <LabeledInput
            {...register('number')}
            label={t('INPUTS.NUMBER')}
            disabled
          />
        </Grid>
        <Grid item xs={12} md={12} lg={8}>
          <LabeledInput
            {...register('addition')}
            defaultValue={mask.data?.addition ?? ''}
            label={t('INPUTS.ADDITION')}
          />
        </Grid>
        <Grid item xs={8} md={8} lg={2}>
          <ControllerPlus
            name="language"
            control={control}
            render={({ field: { ref: _ref, ...fieldProps }, fieldState }) => {
              return (
                <BaseDataLanguagePickerField
                  {...fieldProps}
                  error={fieldState?.error?.message}
                  onChange={(value) => {
                    fieldProps.onChange(value);
                  }}
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={4} md={4} lg={2}>
          <CheckboxRadioItem
            {...register('permanentInvoice')}
            label={t('SERVICECONTRACT.PERMANENT_INVOICE')}
            defaultChecked={isPermanentInvoice}
          />
        </Grid>
      </Grid>
    </Collapse>
  );
};
